import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { usePersonBenefitsDefaultTab } from "./_utils";

export default function PersonBenefitsPage() {
  const { pgaId } = useParams();
  const defaultTab = usePersonBenefitsDefaultTab(pgaId ?? "");

  if (!pgaId) return null;

  return <Navigate to={defaultTab} replace />;
}
